<ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs | async" let-last=last let-first=first>
  @if (first && last) {
    @if (breadcrumb.label.srcIcon != null) {
      <img class="custom-icon-breadcrumb" style="cursor: pointer" [routerLink]="breadcrumb.url" src="{{ breadcrumb.label.srcIcon }}" alt="">
    }
    <span class="text-muted my-auto custom-text-title" style="cursor: pointer" [routerLink]="breadcrumb.url">{{ breadcrumb.label.title }}</span>
  } @else {
    @if (first) {
      @if (breadcrumb.label.srcIcon != null) {
        <img class="custom-icon-breadcrumb" src="{{ breadcrumb.label.srcIcon }}" alt="">
      }
      @if (breadcrumb.clickable) {
        <span class="text-muted my-auto custom-text-title" style="cursor: pointer" [routerLink]="breadcrumb.url">{{ breadcrumb.label.title }}</span>
      } @else {
        <span class="text-muted my-auto custom-text-title" >{{ breadcrumb.label.title }}</span>
      }
    } @else {
      <span style="cursor: pointer" [routerLink]="breadcrumb.url">
      <i class="bi bi-chevron-right me-3 ms-3"></i>
      <span class="text-muted my-auto custom-text-title ">
       @if (breadcrumb.label.srcIcon != null) {
         <img class="custom-icon-breadcrumb" src="{{ breadcrumb.label.srcIcon }}" alt="">
       }

        <a *ngIf="last" [routerLink]="breadcrumb.url" style="color: rgb(33 37 41 / 75%)"> {{ breadcrumb.label.title }}</a>
      <span *ngIf="!last"> {{ breadcrumb.label.title }}</span>

      </span>
      </span>
    }

  }
</ng-template>
